import React, { ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'
import Head from 'next/head'
import Link from 'next/link'
import { AdminHeader } from './AdminHeader'

type Props = {
  children: ReactNode;
  hideHeader?: boolean
  disableCSS?: boolean
};

const Layout: React.FC<Props> = (props) => (
  <div className="admin font-arial-mt">
    <Head>
      <title>AccessKit Admin</title>
      {/* eslint-disable-next-line */}
      {!props.disableCSS && <link rel="stylesheet" href="/styles/admin.css" />}
    </Head>
    {!props.hideHeader && <AdminHeader />}
    {!props.disableCSS && (
      <>
        <div className="admin-layout">{props.children}</div>
        <footer>
          <Link href="https://accesskit.media" className="accesskit-logo">
            {/* eslint-disable-next-line */}
            <img src="/images/2025_logo_black.svg" alt="AccessKit logo." />
            <p>AccessKit</p>
          </Link>
        </footer>
      </>
    )}
    {props.disableCSS && (
      <div>{props.children}</div>
    )}
    <Toaster />
  </div>
)

export default Layout
